export const normalizeSkillName = (name: string): string =>
  name.trim().toLowerCase();
